module.exports = __webpack_public_path__ + "img/ynjt3.511d9f45.jpg";